module.exports = __webpack_public_path__ + "img/xiaohui8.bd9f4514.jpg";